import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class MagicbundleRedeemBaseComponent extends BaseComponent {
  public text: string = "MagicbundleRedeem";

  constructor(userService: UserService) {
    super(userService);
  }
}
